var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseListHeader',[_c('div',{staticClass:"flex -mx-4"},[_c('div',{staticClass:"flex-1 px-4"},[_c('span',{staticClass:"uppercase text-sm"},[_vm._v("number")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }